<template>
    <v-checkbox
        :id="id"
        v-model="modelValue"
        :variant="variant"
        :rules="[rules.required]"
        :color="isValid ? 'success' : undefined"
        :disabled="disabled"
        @update:is-valid="emit('update:isValid', $event)"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ICheckBoxField } from '../../types';
import { useValidation } from '../../composables';

const modelValue = defineModel<boolean>('modelValue', {
    default: false
});

const props = withDefaults(defineProps<ICheckBoxField>(), {
    variant: 'outlined',
    disabled: false
});

const { rules } = useValidation(props);

const isValid = computed(() => modelValue.value);

const emit = defineEmits<{
    (event: 'update:isValid', isValid: boolean): void;
}>();
</script>
